import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import { Grid, TextField } from "@mui/material";
import IconButton from "@mui/material/IconButton";
import InputAdornment from "@mui/material/InputAdornment";
import OutlinedInput from "@mui/material/OutlinedInput";
import { withStyles } from "@mui/styles";
import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { Buffer } from "buffer";
import { encodeData } from "../../components/Comman/Util/Base64";
import swal from "sweetalert";
import FormHelperText from "@mui/material/FormHelperText";
import { login, logOut } from "./login.slice";
import { Loading } from "../../components/Loader";
import { getAccessRoleForLeft } from "../../Slice/stockStakeHolderType.slice";
import { getNoticeMsgByUserType } from "../../Slice/noticeMsg.slice";
import { getSetting } from "../../Slice/setting.slice";
import { showNotification, showLoador } from "../Landing/Landing.slice";
import {
  alreadyLoggedIn,
  authenticationMsg,
  noInternetMsg,
  serverMsg,
  sessionMsg,
} from "../../config/messageconstant";
import { white, DimGrayColor } from "../../config/ColorObj";
import endpoint from "../../config/endpoints";
import { apiGet, apiPostWithoutHeader } from "../../utils/api_service";
import { getActiveLanguage } from "../../Slice/multilingual.slice";
import { getBeatByUserType } from "../../Slice/beat.slice";
const styles = (theme) => ({
  root: {
    height: "100vh",
  },
  top: {
    position: "absolute",
    right: 0,
    top: 0,
  },
  bottom: {
    position: "absolute",
    left: 0,
    bottom: 0,
  },
  ellipse: {
    // position: "static",
    // width: "517px",
    // height: "350px",
    // left: "10px",
    // top: "10px",

    // background: "rgba(41, 151, 171, 0.2)",
    // flex: "none",
    // order: "0",
    // flexgrow: "0",
    justifyContent: "center",
  },
  loginBox: {
    display: "flex",
    border: `1px solid ${theme.palette.grey[400]}`,
    margin: "50px",
    width: "auto",
    zIndex: "1",
    backgroundColor: "white",
  },
  text: {
    fontfamily: "Roboto",
    fontstyle: "normal",
    fontweight: "bold",
    fontsize: "32px",
    textAlign: "center",

    color: white,
  },
  bmn: {
    padding: "30px",
    justifyContent: "center",

    // alignSelf:'center',
  },
  left: {
    //  width: "50%",
  },
  hello: {
    textAlign: "center",
    top: "60px",
    left: "50px",
  },
  helper: {
    textAlign: "center",
    height: "56px",
    fontfamily: "Roboto",
    fontstyle: "normal",
    fontweight: "normal",
    fontsize: "18px",
    lineheight: "28px",
    color: DimGrayColor,
  },
  field: {
    padding: "10px 50px",
    margin: "50px",
  },
  stay: {
    fontfamily: "Roboto",
    fontstyle: "normal",
    fontweight: "normal",
    fontsize: "14px",
    lineheight: "28px",
    paddingLeft: "20px",

    color: DimGrayColor,
  },
  ellipse2: {
    width: "504px",
    height: "504px",
    left: "-139px",
    top: "500px",

    background: white,
    border: "80px solid #2997AB",
    boxsizing: "border-box",
  },
  fogot: {
    left: "500px",
  },
  body: { backgroundColor: "#f5f5f5" },
});

const initState = { name: "", password: "" };
const CARRIED_TOKEN_LOGIN_FLAG = "carriedDmsLogin";

const Login = ({
  login,
  logOut,
  showLoador,
  showNotification,
  getAccessRoleForLeft,
  getNoticeMsgByUserType,
  getSetting,
  getActiveLanguage,
  getBeatByUserType,
}) => {
  const [auth, setAuth] = useState(initState);
  const [nameErr, setNameErr] = useState("");
  const [passwordErr, setPasswordErr] = useState("");
  const [loginErr, setLoginErr] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [showLoading, setShowLoading] = useState(false);
  const [sessionExpire, showSessionExpire] = useState(true);

  useEffect(() => {
    const carriedToken = new URLSearchParams(window.location.search).get("token");
    if (carriedToken && carriedToken.trim()) {
      return;
    }
    const name = localStorage.getItem("token");
    const loginCheck = localStorage.getItem("loginCheck");
    if (name !== "" && name !== null) {
      window.location.replace("/welcome-page");
    }
    if (loginCheck !== null && loginCheck !== "" && loginCheck == "0") {
      showSessionError();
    }
  }, []);
  const showSessionError = () => {
    swal({
      title: sessionMsg,
      text: "You are Log out because your account is Logged in from another device",
      icon: "error",
      timer: 10000,
      showCancelButton: false,
      showConfirmButton: false,
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        localStorage.clear();
      }
      localStorage.clear();
    });
  };

  const getSettingKeysFunction = async () => {
    await getSetting().then(async ({ response, success }) => {
      if (!success) {
        showLoador({ loador: false });
        showNotification({
          msg: serverMsg,
          severity: "error",
        });
        if (sessionStorage.getItem(CARRIED_TOKEN_LOGIN_FLAG) === "1") {
          sessionStorage.removeItem(CARRIED_TOKEN_LOGIN_FLAG);
          localStorage.removeItem("token");
        }
      } else {
        sessionStorage.removeItem(CARRIED_TOKEN_LOGIN_FLAG);
        showLoador({ loador: true });

        let isMaintainanceList = response.filter(
          (row) => row.settingKey == "is_maintainance"
        );

        if (isMaintainanceList[0].settingValue == "1") {
          window.location.replace("/maintainance");
        } else {
          let showPdfObject = response.find(
            (row) => row.settingKey == "show_pdf"
          );

          if (showPdfObject) {
            localStorage.setItem(
              "showPdf",
              showPdfObject.settingValue
            );
          }

          let isFreezTargetList = response.filter(
            (row) => row.settingKey == "is_freez_target"
          );
          localStorage.setItem(
            "isFreezTarget",
            isFreezTargetList.length == 0
              ? ""
              : isFreezTargetList[0].settingValue
          );

          let dateValidationList = response.filter(
            (row) =>
              row.settingKey ==
              "show_date_validation_on_dynamic_reports"
          );

          localStorage.setItem(
            "showDateValidationOnDynamicReports",
            dateValidationList.length == 0
              ? ""
              : dateValidationList[0].settingValue
          );

          let stockHolderSortOrderNo = response.find(
            (row) =>
              row.settingKey == "stock_holder_sort_order_no"
          );

          if (stockHolderSortOrderNo) {
            localStorage.setItem(
              "stockHolderSortOrderNo",
              stockHolderSortOrderNo.settingValue
            );
          }
          let showSapCreditLimitList = response.filter(
            (row) => row.settingKey == "show_sap_credit_limit"
          );

          localStorage.setItem(
            "showSapCredtLimit",
            showSapCreditLimitList.length == 0
              ? ""
              : showSapCreditLimitList[0].settingValue
          );

          let filterDataExcelList = response.filter(
            (row) => row.settingKey == "show_filter_data_excel"
          );

          localStorage.setItem(
            "showFilterDataWiseExcel",
            filterDataExcelList.length == 0
              ? ""
              : filterDataExcelList[0].settingValue
          );

          let areaDistrictColumnList = response.filter(
            (row) =>
              row.settingKey ==
              "area_district_column_on_sales_team_list_dashboard"
          );

          localStorage.setItem(
            "showAreaDistrictColumnsOnSalesTeamListDashboard",
            areaDistrictColumnList.length == 0
              ? ""
              : areaDistrictColumnList[0].settingValue
          );

          let isQtyInBatchwiseList = response.filter(
            (row) => row.settingKey == "is_qty_in_batchwise"
          );
          localStorage.setItem(
            "isQtyInBatchWise",
            isQtyInBatchwiseList.length == 0
              ? ""
              : isQtyInBatchwiseList[0].settingValue
          );

          let isClosingQtyClickableList = response.filter(
            (row) => row.settingKey == "is_closing_qty_clickable"
          );
          localStorage.setItem(
            "isClosingQtyClickable",
            isClosingQtyClickableList.length == 0
              ? ""
              : isClosingQtyClickableList[0].settingValue
          );

          let showCompanyFlagList = response.filter(
            (row) => row.settingKey == "show_excel_reports"
          );
          localStorage.setItem(
            "showCompanyFlag",
            showCompanyFlagList.length == 0
              ? ""
              : showCompanyFlagList[0].settingValue
          );

          let stockCalAtBillLis = response.filter(
            (row) => row.settingKey == "stock_cal_at_bill"
          );
          localStorage.setItem(
            "stockCalAtBill",
            stockCalAtBillLis.length == 0
              ? ""
              : stockCalAtBillLis[0].settingValue
          );

          let showAllApiForDistributorDashboardList =
            response.filter(
              (row) =>
                row.settingKey ==
                "show_all_api_for_distributor_dashboard"
            );
          localStorage.setItem(
            "showAllApiForDistributorDashboard",
            showAllApiForDistributorDashboardList.length == 0
              ? ""
              : showAllApiForDistributorDashboardList[0]
                .settingValue
          );

          let showMlogIconList = response.filter(
            (row) => row.settingKey == "is_show_mlog_icon"
          );
          localStorage.setItem(
            "isShowMlogIcon",
            showMlogIconList.length == 0
              ? ""
              : showMlogIconList[0].settingValue
          );

          let showCategoryWiseAnalysisList = response.filter(
            (row) =>
              row.settingKey == "is_show_category_wise_analysis"
          );
          localStorage.setItem(
            "isShowCategoryWiseAnalysis",
            showCategoryWiseAnalysisList.length == 0
              ? ""
              : showCategoryWiseAnalysisList[0].settingValue
          );

          let showColumnsAreaMsterList = response.filter(
            (row) =>
              row.settingKey ==
              "is_show_sales_team_count_area_table"
          );
          localStorage.setItem(
            "isShowSalesTeamCountAreaTable",
            showColumnsAreaMsterList.length == 0
              ? ""
              : showColumnsAreaMsterList[0].settingValue
          );

          let showBeatAssignValidationList = response.filter(
            (row) =>
              row.settingKey ==
              "is_beat_assign_Validation_for_sales_executive"
          );
          localStorage.setItem(
            "isBeatAssignValidationForSalesExecutive",
            showBeatAssignValidationList.length == 0
              ? ""
              : showBeatAssignValidationList[0].settingValue
          );

          let showStockHolderTypeDisableList = response.filter(
            (row) =>
              row.settingKey ==
              "is_stockholder_type_disable_on_edit"
          );
          localStorage.setItem(
            "isStockholderTypeDisableOnEdit",
            showStockHolderTypeDisableList.length == 0
              ? ""
              : showStockHolderTypeDisableList[0].settingValue
          );

          let showSalesTeamConfigurationManageList =
            response.filter(
              (row) =>
                row.settingKey ==
                "is_sales_team_configuration_manage"
            );
          localStorage.setItem(
            "isSalesTeamConfigurationManage",
            showSalesTeamConfigurationManageList.length == 0
              ? ""
              : showSalesTeamConfigurationManageList[0]
                .settingValue
          );

          let showOutletTargetFyDateList = response.filter(
            (row) => row.settingKey == "outlet_target_fy_date"
          );
          localStorage.setItem(
            "isOutletTargetFyDate",
            showOutletTargetFyDateList.length == 0
              ? ""
              : showOutletTargetFyDateList[0].settingValue
          );

          let showTownInBeat = response.filter(
            (row) => row.settingKey == "show_town_in_beat"
          );
          localStorage.setItem(
            "isShowTownInBeat",
            showTownInBeat.length == 0
              ? ""
              : showTownInBeat[0].settingValue
          );

          let showBeatAllowanceTypesNames = response.filter(
            (row) =>
              row.settingKey == "beat_allowance_types_names"
          );
          localStorage.setItem(
            "isShowBeatAllowanceTypesNames",
            showBeatAllowanceTypesNames.length == 0
              ? ""
              : showBeatAllowanceTypesNames[0].settingValue
          );

          let showUpdateToAllButton = response.filter(
            (row) => row.settingKey == "show_update_to_all_button"
          );
          localStorage.setItem(
            "isShowUpdateToAllButton",
            showUpdateToAllButton.length == 0
              ? ""
              : showUpdateToAllButton[0].settingValue
          );

          let showProductAndStocksList = response.filter(
            (row) =>
              row.settingKey == "stock_empty_for_primary_billing"
          );
          localStorage.setItem(
            "isShowStocksEmptyForPrimaryBilling",
            showProductAndStocksList.length == 0
              ? ""
              : showProductAndStocksList[0].settingValue
          );

          let showStockDisableList = response.filter(
            (row) => row.settingKey == "show_stock_disable"
          );
          localStorage.setItem(
            "showStockDisable",
            showStockDisableList.length == 0
              ? ""
              : showStockDisableList[0].settingValue
          );

          let lostOrderFromBillingList = response.filter(
            (row) => row.settingKey == "lost_order_from_billing"
          );
          localStorage.setItem(
            "lostOrderFromBilling",
            lostOrderFromBillingList.length == 0
              ? ""
              : lostOrderFromBillingList[0].settingValue
          );

          let showFreeQtyPercetageList = response.filter(
            (row) => row.settingKey == "show_free_qty_percentage"
          );
          localStorage.setItem(
            "showFreeQtyPercetage",
            showFreeQtyPercetageList.length == 0
              ? ""
              : showFreeQtyPercetageList[0].settingValue
          );

          let transporterInsertedList = response.filter(
            (row) => row.settingKey == "transporter_inserted"
          );
          localStorage.setItem(
            "transporterInserted",
            transporterInsertedList.length == 0
              ? ""
              : transporterInsertedList[0].settingValue
          );

          let orderWithBillingForAdminList = response.filter(
            (row) =>
              row.settingKey == "order_with_billing_for_admin"
          );
          localStorage.setItem(
            "orderWithBillingForAdmin",
            orderWithBillingForAdminList.length == 0
              ? ""
              : orderWithBillingForAdminList[0].settingValue
          );

          let manualOrderWithBillingForPrimaryList =
            response.filter(
              (row) =>
                row.settingKey ==
                "manual_order_with_billing_for_primary"
            );
          localStorage.setItem(
            "manualOrderWithBillingForPrimary",
            manualOrderWithBillingForPrimaryList.length == 0
              ? ""
              : manualOrderWithBillingForPrimaryList[0]
                .settingValue
          );

          let attendanceTargetAchievementFlagList =
            response.filter(
              (row) =>
                row.settingKey ==
                "show_attendance_target_achievement"
            );
          localStorage.setItem(
            "showAttendanceTargetAchievement",
            attendanceTargetAchievementFlagList.length == 0
              ? ""
              : attendanceTargetAchievementFlagList[0]
                .settingValue
          );

          let salesTeamCompleteHierarchyList = response.filter(
            (row) =>
              row.settingKey ==
              "show_complete_hierarchy_sales_team"
          );
          localStorage.setItem(
            "showCompleteHierarchyToSalesTeam",
            salesTeamCompleteHierarchyList.length == 0
              ? ""
              : salesTeamCompleteHierarchyList[0].settingValue
          );

          let staticDeleteToAreaList = response.filter(
            (row) =>
              row.settingKey == "show_static_delete_to_area"
          );
          localStorage.setItem(
            "showStaticDeleteToArea",
            staticDeleteToAreaList.length == 0
              ? ""
              : staticDeleteToAreaList[0].settingValue
          );

          let staticDeleteGroupProductList = response.filter(
            (row) =>
              row.settingKey ==
              "show_static_delete_to_group_product"
          );
          localStorage.setItem(
            "showStaticDeleteToGroupProduct",
            staticDeleteGroupProductList.length == 0
              ? ""
              : staticDeleteGroupProductList[0].settingValue
          );

          let packagingTypeAmountsList = response.filter(
            (row) =>
              row.settingKey == "show_packaging_type_amounts"
          );
          localStorage.setItem(
            "showPackagingTypeAmounts",
            packagingTypeAmountsList.length == 0
              ? ""
              : packagingTypeAmountsList[0].settingValue
          );

          let checkInImageFlagList = response.filter(
            (row) =>
              row.settingKey == "is_check_in_image_mandatory"
          );
          localStorage.setItem(
            "checkInImage",
            checkInImageFlagList.length == 0
              ? ""
              : checkInImageFlagList[0].settingValue
          );

          let zeroOrderImageFlagList = response.filter(
            (row) => row.settingKey == "is_add_zero_order_image"
          );
          localStorage.setItem(
            "zeroOrderImage",
            zeroOrderImageFlagList.length == 0
              ? ""
              : zeroOrderImageFlagList[0].settingValue
          );

          let timelineManagerLogsWiseList = response.filter(
            (row) =>
              row.settingKey == "show_timeline_manager_logs_wise"
          );
          localStorage.setItem(
            "showTimelineManagerLogsWise",
            timelineManagerLogsWiseList.length == 0
              ? ""
              : timelineManagerLogsWiseList[0].settingValue
          );

          let orderConfigurationTimeList = response.filter(
            (row) => row.settingKey == "show_order_config_time"
          );
          localStorage.setItem(
            "showOrderConfigurationByTime",
            orderConfigurationTimeList.length == 0
              ? ""
              : orderConfigurationTimeList[0].settingValue
          );

          let showPastOrderInTimelineList = response.filter(
            (row) =>
              row.settingKey == "show_past_order_in_timeline"
          );
          localStorage.setItem(
            "showPastOrderInTimeline",
            showPastOrderInTimelineList.length == 0
              ? ""
              : showPastOrderInTimelineList[0].settingValue
          );

          let showUpdateAndSubmitList = response.filter(
            (row) =>
              row.settingKey ==
              "show_update_and_submit_in_user_access"
          );
          localStorage.setItem(
            "showUpdateAndSubmitInUserAccess",
            showUpdateAndSubmitList.length == 0
              ? ""
              : showUpdateAndSubmitList[0].settingValue
          );

          let secondaryQtyWiseStockList = response.filter(
            (row) => row.settingKey == "secondary_qty_wise_stock"
          );
          localStorage.setItem(
            "secondaryQtyWiseStock",
            secondaryQtyWiseStockList.length == 0
              ? ""
              : secondaryQtyWiseStockList[0].settingValue
          );

          let showPrimarySellQty = response.find(
            (row) =>
              row.settingKey ==
              "show_primary_sell_qty_stock_between"
          );

          if (showPrimarySellQty) {
            localStorage.setItem(
              "showPrimarySellQtyStockBtwDate",
              showPrimarySellQty.settingValue
            );
          }

          let showImgUrlDms = response.find(
            (row) => row.settingKey == "img_url_dms"
          );

          if (showImgUrlDms) {
            localStorage.setItem(
              "showImgUrlDms",
              showImgUrlDms.settingValue
            );
          }

          let showTargetTypeRadioGroup = response.find(
            (row) =>
              row.settingKey == "show_target_type_radio_group"
          );

          if (showTargetTypeRadioGroup) {
            localStorage.setItem(
              "showTargetTypeRadioGroup",
              showTargetTypeRadioGroup.settingValue
            );
          }

          let getClaimTypeValue = response.find(
            (row) => row.settingKey == "get-claim-type-value"
          );

          if (getClaimTypeValue) {
            localStorage.setItem(
              "getClaimTypeValue",
              getClaimTypeValue.settingValue
            );
          }

          let showBeatTypeAndDistance = response.find(
            (row) =>
              row.settingKey == "show_beat_type_and_distance"
          );

          if (showBeatTypeAndDistance) {
            localStorage.setItem(
              "showBeatTypeAndDistance",
              showBeatTypeAndDistance.settingValue
            );
          }

          let showClaimTypes = response.find(
            (row) => row.settingKey == "is_show_claim_types"
          );

          if (showClaimTypes) {
            localStorage.setItem(
              "isShowClaimTypes",
              showClaimTypes.settingValue
            );
          }

          let showIsRateApplicableOutlet = response.find(
            (row) =>
              row.settingKey == "show_is_rate_applicable_outlet"
          );

          if (showIsRateApplicableOutlet) {
            localStorage.setItem(
              "showIsRateApplicableOutlet",
              showIsRateApplicableOutlet.settingValue
            );
          }

          let showRadioGroupForCentralizedStructureForm =
            response.find(
              (row) =>
                row.settingKey ==
                "show_radiogroup_for_centralizedstructure_form"
            );

          if (showRadioGroupForCentralizedStructureForm) {
            localStorage.setItem(
              "showRadioGroupForCentralizedStructureForm",
              showRadioGroupForCentralizedStructureForm.settingValue
            );
          }

          let radioPurchasereturnAndExpiryForRatestructure =
            response.find(
              (row) =>
                row.settingKey ==
                "radio_purchasereturn_and_expiry_for_ratestructure"
            );

          if (radioPurchasereturnAndExpiryForRatestructure) {
            localStorage.setItem(
              "radioPurchasereturnAndExpiryForRatestructure",
              radioPurchasereturnAndExpiryForRatestructure.settingValue
            );
          }

          let purchaseReturnShowOtherRadioGroups = response.find(
            (row) =>
              row.settingKey ==
              "purchase_return_show_other_radiogroup"
          );

          if (purchaseReturnShowOtherRadioGroups) {
            localStorage.setItem(
              "purchaseReturnShowOtherRadioGroups",
              purchaseReturnShowOtherRadioGroups.settingValue
            );
          }

          let showFilterOnReceivedOrder = response.find(
            (row) =>
              row.settingKey == "show_filter_on_received_order"
          );

          if (showFilterOnReceivedOrder) {
            localStorage.setItem(
              "showFilterOnReceivedOrder",
              showFilterOnReceivedOrder.settingValue
            );
          }

          let showSalesTeamTypeAtOutletInvoicing = response.find(
            (row) =>
              row.settingKey ==
              "show_sales_team_type_outlet_invoicing"
          );

          if (showSalesTeamTypeAtOutletInvoicing) {
            localStorage.setItem(
              "showSalesTeamTypeAtOutletInvoicing",
              showSalesTeamTypeAtOutletInvoicing.settingValue
            );
          }

          let isRateEditableForHoreca = response.find(
            (row) =>
              row.settingKey == "is_rate_editable_for_horeca"
          );

          if (isRateEditableForHoreca) {
            localStorage.setItem(
              "isRateEditableForHoreca",
              isRateEditableForHoreca.settingValue
            );
          }

          let isDistributorInactiveSaveInLog = response.find(
            (row) =>
              row.settingKey == "distributor_inactive_save_in_log"
          );

          if (isDistributorInactiveSaveInLog) {
            localStorage.setItem(
              "isDistributorInactiveSaveInLog",
              isDistributorInactiveSaveInLog.settingValue
            );
          }

          let showExcelInProductRateStructureList = response.find(
            (row) =>
              row.settingKey ==
              "show_excel_in_rate_structure_list"
          );

          if (showExcelInProductRateStructureList) {
            localStorage.setItem(
              "showExcelInProductRateStructureList",
              showExcelInProductRateStructureList.settingValue
            );
          }

          let showPanIndiaOffer = response.find(
            (row) => row.settingKey == "show_pan_india_offer"
          );

          if (showPanIndiaOffer) {
            localStorage.setItem(
              "showPanIndiaOffer",
              showPanIndiaOffer.settingValue
            );
          }

          let isOutletMappedToDistributor = response.find(
            (row) =>
              row.settingKey == "is_outlet_mapped_to_distributor"
          );

          if (isOutletMappedToDistributor) {
            localStorage.setItem(
              "isOutletMappedToDistributor",
              isOutletMappedToDistributor.settingValue
            );
          }

          let showMultipleAreasToDistributor = response.find(
            (row) =>
              row.settingKey ==
              "show_multiple_areas_to_distributor"
          );

          if (showMultipleAreasToDistributor) {
            localStorage.setItem(
              "showMultipleAreasToDistributor",
              showMultipleAreasToDistributor.settingValue
            );
          }

          let showStockHolderStructureDetails = response.find(
            (row) =>
              row.settingKey ==
              "show_stock_holder_structure_details"
          );

          if (showStockHolderStructureDetails) {
            localStorage.setItem(
              "showStockHolderStructureDetails",
              showStockHolderStructureDetails.settingValue
            );
          }

          let showExcelReportsBySettingValues = response.find(
            (row) =>
              row.settingKey ==
              "show_excel_reports_by_setting_values"
          );

          if (showExcelReportsBySettingValues) {
            localStorage.setItem(
              "showExcelReportsBySettingValues",
              showExcelReportsBySettingValues.settingValue
            );
          }

          let showRealTimeTracking = response.find(
            (row) =>
              row.settingKey == "is_show_real_time_tracking"
          );

          if (showRealTimeTracking) {
            localStorage.setItem(
              "showRealTimeTracking",
              showRealTimeTracking.settingValue
            );
          }

          let projectionBeatApplicable = response.find(
            (row) =>
              row.settingKey == "projection_beat_applicable"
          );

          if (projectionBeatApplicable) {
            localStorage.setItem(
              "projectionBeatApplicable",
              projectionBeatApplicable.settingValue
            );
          }

          let dayEndUsingDailyAllowance = response.find(
            (row) =>
              row.settingKey == "day_end_using_daily_allowance"
          );

          if (dayEndUsingDailyAllowance) {
            localStorage.setItem(
              "dayEndUsingDailyAllowance",
              dayEndUsingDailyAllowance.settingValue
            );
          }

          let showAnalyticsIcon = response.find(
            (row) => row.settingKey == "show_analytics_icon"
          );

          if (showAnalyticsIcon) {
            localStorage.setItem(
              "showAnalyticsIcon",
              showAnalyticsIcon.settingValue
            );
          }

          let showBillingAtOutletOrderHistory = response.find(
            (row) =>
              row.settingKey ==
              "show_billing_at_outlet_order_history"
          );

          if (showBillingAtOutletOrderHistory) {
            localStorage.setItem(
              "showBillingAtOutletOrderHistory",
              showBillingAtOutletOrderHistory.settingValue
            );
          }

          let isCreditLimitApplicable = response.find(
            (row) =>
              row.settingKey == "is_credit_limit_Applicable"
          );

          if (isCreditLimitApplicable) {
            localStorage.setItem(
              "isCreditLimitApplicable",
              isCreditLimitApplicable.settingValue
            );
          }

          let multipleRegionForManager = response.find(
            (row) =>
              row.settingKey ==
              "is_show_multiple_region_at_manager"
          );

          if (multipleRegionForManager) {
            localStorage.setItem(
              "multipleRegionForManager",
              multipleRegionForManager.settingValue
            );
          }

          let isShowDojAtSalesTeam = response.find(
            (row) => row.settingKey == "is_show_doj_at_sales_team"
          );

          if (isShowDojAtSalesTeam) {
            localStorage.setItem(
              "isShowDojAtSalesTeam",
              isShowDojAtSalesTeam.settingValue
            );
          }

          let subChannelWiseOutletType = response.find(
            (row) =>
              row.settingKey == "is_sub_channel_wise_outlet_type"
          );

          if (subChannelWiseOutletType) {
            localStorage.setItem(
              "subChannelWiseOutletType",
              subChannelWiseOutletType.settingValue
            );
          }

          let isPanIndiaNotice = response.find(
            (row) => row.settingKey == "is_pan_india_notice"
          );

          if (isPanIndiaNotice) {
            localStorage.setItem(
              "isPanIndiaNotice",
              isPanIndiaNotice.settingValue
            );
          }

          let isShowDiscountAtPrimaryBilling = response.find(
            (row) =>
              row.settingKey ==
              "is_show_discount_at_primary_billing"
          );

          if (isShowDiscountAtPrimaryBilling) {
            localStorage.setItem(
              "isShowDiscountAtPrimaryBilling",
              isShowDiscountAtPrimaryBilling.settingValue
            );
          }

          let isShowItemDiscountAtPrimaryBilling = response.find(
            (row) =>
              row.settingKey ==
              "is_show_item_wise_discount_at_primary_billing"
          );

          if (isShowItemDiscountAtPrimaryBilling) {
            localStorage.setItem(
              "isShowItemDiscountAtPrimaryBilling",
              isShowItemDiscountAtPrimaryBilling.settingValue
            );
          }

          let isShowSalesTeamTypeAtAnalyticalAdminDash =
            response.find(
              (row) =>
                row.settingKey ==
                "is_show_sales_team_type_at_analytical_dash"
            );

          if (isShowSalesTeamTypeAtAnalyticalAdminDash) {
            localStorage.setItem(
              "isShowSalesTeamTypeAtAnalyticalAdminDash",
              isShowSalesTeamTypeAtAnalyticalAdminDash.settingValue
            );
          }

          let isShowMultiselectionAtOutletMoving = response.find(
            (row) =>
              row.settingKey ==
              "is_show_multiselection_at_outlet_moving"
          );

          if (isShowMultiselectionAtOutletMoving) {
            localStorage.setItem(
              "isShowMultiselectionAtOutletMoving",
              isShowMultiselectionAtOutletMoving.settingValue
            );
          }

          let brandIdForBillPdf = response.find(
            (row) =>
              row.settingKey == "brand_id_for_bill_pdf_logo"
          );

          if (brandIdForBillPdf) {
            localStorage.setItem(
              "brandIdForBillPdf",
              brandIdForBillPdf.settingValue
            );
          }

          let isShowLogoAtBillPdf = response.find(
            (row) => row.settingKey == "is_show_logo_at_bill_pdf"
          );

          if (isShowLogoAtBillPdf) {
            localStorage.setItem(
              "isShowLogoAtBillPdf",
              isShowLogoAtBillPdf.settingValue
            );
          }

          let isShowReportingAtSalesExecutiveColumn =
            response.find(
              (row) =>
                row.settingKey ==
                "is_show_reporting_at_sales_executive"
            );

          if (isShowReportingAtSalesExecutiveColumn) {
            localStorage.setItem(
              "isShowReportingAtSalesExecutiveColumn",
              isShowReportingAtSalesExecutiveColumn.settingValue
            );
          }

          let isShowSalesTeamModuleOverTheManager = response.find(
            (row) =>
              row.settingKey ==
              "is_show_sales_team_module_over_the_manager"
          );

          if (isShowSalesTeamModuleOverTheManager) {
            localStorage.setItem(
              "isShowSalesTeamModuleOverTheManager",
              isShowSalesTeamModuleOverTheManager.settingValue
            );
          }

          let isShowDetailMapButton = response.find(
            (row) => row.settingKey == "is_show_detail_map_button"
          );

          if (isShowDetailMapButton) {
            localStorage.setItem(
              "isShowDetailMapButton",
              isShowDetailMapButton.settingValue
            );
          }

          let isShowTimelineMapStoppage = response.find(
            (row) =>
              row.settingKey == "timeline_map_stoppage_setting"
          );

          if (isShowTimelineMapStoppage) {
            localStorage.setItem(
              "isShowTimelineMapStoppage",
              isShowTimelineMapStoppage.settingValue
            );
          }

          let isShowLeaveAuthorityWiseData = response.find(
            (row) =>
              row.settingKey == "get_leave_authority_wise_data"
          );

          if (isShowLeaveAuthorityWiseData) {
            localStorage.setItem(
              "getLeaveAuthorityWiseData",
              isShowLeaveAuthorityWiseData.settingValue
            );
          }

          let isShowClaimAuthorityWiseData = response.find(
            (row) =>
              row.settingKey == "get_claim_authority_wise_data"
          );

          if (isShowClaimAuthorityWiseData) {
            localStorage.setItem(
              "getClaimAuthorityWiseData",
              isShowClaimAuthorityWiseData.settingValue
            );
          }

          let isSalesTeamTypeDisabledOnEdit = response.find(
            (row) =>
              row.settingKey ==
              "is_salesteam_type_disable_on_edit"
          );

          if (isSalesTeamTypeDisabledOnEdit) {
            localStorage.setItem(
              "isSalesTeamTypeDisabledOnEdit",
              isSalesTeamTypeDisabledOnEdit.settingValue
            );
          }

          let isShowOutletEditAndSequenceWiseOrder =
            response.find(
              (row) =>
                row.settingKey ==
                "is_show_outlet_edit_and_sequence_wise_order"
            );

          if (isShowOutletEditAndSequenceWiseOrder) {
            localStorage.setItem(
              "isShowOutletEditAndSequenceWiseOrder",
              isShowOutletEditAndSequenceWiseOrder.settingValue
            );
          }

          let isShowOwnerNameAtBillPdf = response.find(
            (row) =>
              row.settingKey == "is_show_owner_name_at_bill_pdf"
          );

          if (isShowOwnerNameAtBillPdf) {
            localStorage.setItem(
              "isShowOwnerNameAtBillPdf",
              isShowOwnerNameAtBillPdf.settingValue
            );
          }

          let isShowLeaveAndClaimAuthorityType = response.find(
            (row) =>
              row.settingKey ==
              "is_show_leave_and_claim_authority_type"
          );

          if (isShowLeaveAndClaimAuthorityType) {
            localStorage.setItem(
              "isShowLeaveAndClaimAuthorityType",
              isShowLeaveAndClaimAuthorityType.settingValue
            );
          }

          let isTaDaClaimAmountEditable = response.find(
            (row) =>
              row.settingKey == "is_ta_da_claim_amt_editable"
          );

          if (isTaDaClaimAmountEditable) {
            localStorage.setItem(
              "isTaDaClaimAmountEditable",
              isTaDaClaimAmountEditable.settingValue
            );
          }

          let showAddButtonInDayend = response.find(
            (row) => row.settingKey == "show_add_button_in_dayend"
          );

          if (showAddButtonInDayend) {
            localStorage.setItem(
              "showAddButtonInDayend",
              showAddButtonInDayend.settingValue
            );
          }

          let isShowDateFilterOnlyOnSalesTeamAtAnalyticalAdminDash =
            response.find(
              (row) =>
                row.settingKey ==
                "is_show_date_filter_on_analytical_admin_dashboard"
            );

          if (
            isShowDateFilterOnlyOnSalesTeamAtAnalyticalAdminDash
          ) {
            localStorage.setItem(
              "isShowDateFilterOnlyOnSalesTeamAtAnalyticalAdminDash",
              isShowDateFilterOnlyOnSalesTeamAtAnalyticalAdminDash.settingValue
            );
          }

          let getBeatTypeNames = response.find(
            (row) => row.settingKey == "get_beat_type_names"
          );

          if (getBeatTypeNames) {
            localStorage.setItem(
              "getBeatTypeNames",
              getBeatTypeNames.settingValue
            );
          }

          let showExcelInsteadOfClaimPdf = response.find(
            (row) =>
              row.settingKey == "show_excel_instead_claim_pdf"
          );

          if (showExcelInsteadOfClaimPdf) {
            localStorage.setItem(
              "showExcelInsteadOfClaimPdf",
              showExcelInsteadOfClaimPdf.settingValue
            );
          }

          let showReverseSequenceForProductRateStructure =
            response.find(
              (row) =>
                row.settingKey ==
                "is_show_reverse_sequence_product_rate_structure"
            );

          if (showReverseSequenceForProductRateStructure) {
            localStorage.setItem(
              "showReverseSequenceForProductRateStructure",
              showReverseSequenceForProductRateStructure.settingValue
            );
          }

          let showValidationAtProductRateStructure =
            response.find(
              (row) =>
                row.settingKey ==
                "is_show_product_rate_structure_validation"
            );

          if (showValidationAtProductRateStructure) {
            localStorage.setItem(
              "showValidationAtProductRateStructure",
              showValidationAtProductRateStructure.settingValue
            );
          }

          let hideStock = response.find(
            (row) => row.settingKey == "hide_stock"
          );

          if (hideStock) {
            localStorage.setItem(
              "hideStock",
              hideStock.settingValue
            );
          }

          let daysForPrimaryOrderOnLoad =
            response.find(
              (row) =>
                row.settingKey ==
                "days_for_primary_order_onload_api"
            );

          if (
            daysForPrimaryOrderOnLoad
          ) {
            localStorage.setItem(
              "daysForPrimaryOrderOnLoad",
              daysForPrimaryOrderOnLoad.settingValue
            );
          }

          let companyLogoExpand =
            response.find(
              (row) =>
                row.settingKey ==
                "is_company_logo_expand"
            );

          if (
            companyLogoExpand
          ) {
            localStorage.setItem(
              "companyLogoExpand",
              companyLogoExpand.settingValue
            );
          }

          let isShowOnloadOutletApi =
            response.find(
              (row) =>
                row.settingKey ==
                "is_show_onload_outlet_api"
            );

          if (
            isShowOnloadOutletApi
          ) {
            localStorage.setItem(
              "isShowOnloadOutletApi",
              isShowOnloadOutletApi.settingValue
            );
          }


          let showOrderNotificationIcon =
            response.find(
              (row) =>
                row.settingKey ==
                "notification_on_for_primary_order"
            );

          if (
            showOrderNotificationIcon
          ) {
            localStorage.setItem(
              "showOrderNotificationIcon",
              showOrderNotificationIcon.settingValue
            );
          }


          let companyLogo =
            response.find(
              (row) =>
                row.settingKey ==
                "company_logo"
            );

          if (
            companyLogo
          ) {
            localStorage.setItem(
              "companyLogo",
              companyLogo.settingValue
            );
          }

          let showSupplyTypeAtRuTarget =
            response.find(
              (row) =>
                row.settingKey ==
                "show_supply_type_at_ru_target"
            );

          if (
            showSupplyTypeAtRuTarget
          ) {
            localStorage.setItem(
              "showSupplyTypeAtRuTarget",
              showSupplyTypeAtRuTarget.settingValue
            );
          }

          let hideStockHolderOnOrderApproval =
            response.find(
              (row) =>
                row.settingKey ==
                "hide_stockholder_on_order_approval"
            );

          if (
            hideStockHolderOnOrderApproval
          ) {
            localStorage.setItem(
              "hideStockHolderOnOrderApproval",
              hideStockHolderOnOrderApproval.settingValue
            );
          }

          let isShowLeaveYear =
            response.find(
              (row) =>
                row.settingKey ==
                "is_show_leave_year_at_leave_structure_assignation"
            );

          if (
            isShowLeaveYear
          ) {
            localStorage.setItem(
              "isShowLeaveYear",
              isShowLeaveYear.settingValue
            );
          }


          let isShowExtraFieldAtLeaveStructure =
            response.find(
              (row) =>
                row.settingKey ==
                "is_show_extra_field_at_leave_structure"
            );

          if (
            isShowExtraFieldAtLeaveStructure
          ) {
            localStorage.setItem(
              "isShowExtraFieldAtLeaveStructure",
              isShowExtraFieldAtLeaveStructure.settingValue
            );
          }


          let isShowPromoterTrackingAndChefWorking =
            response.find(
              (row) =>
                row.settingKey ==
                "is_show_promoter_tracking_and_chef_working"
            );

          if (
            isShowPromoterTrackingAndChefWorking
          ) {
            localStorage.setItem(
              "isShowPromoterTrackingAndChefWorking",
              isShowPromoterTrackingAndChefWorking.settingValue
            );
          }

          let noOfLicenseCount =
            response.find(
              (row) =>
                row.settingKey ==
                "no_of_license_count"
            );

          if (
            noOfLicenseCount
          ) {
            localStorage.setItem(
              "noOfLicenseCount",
              noOfLicenseCount.settingValue
            );
          }

          let isShowLeaveIconAtSalesTeam =
            response.find(
              (row) =>
                row.settingKey ==
                "is_show_leave_icon_at_sales_team"
            );

          if (
            isShowLeaveIconAtSalesTeam
          ) {
            localStorage.setItem(
              "isShowLeaveIconAtSalesTeam",
              isShowLeaveIconAtSalesTeam.settingValue
            );
          }


          let isCallProductWithOrderValueApiOnSync =
            response.find(
              (row) =>
                row.settingKey ==
                "is_call_with_order_value_api"
            );

          if (
            isCallProductWithOrderValueApiOnSync
          ) {
            localStorage.setItem(
              "isCallProductWithOrderValueApiOnSync",
              isCallProductWithOrderValueApiOnSync.settingValue
            );
          }

          let isReplaceDashboardToAnalyticalOnSync =
            response.find(
              (row) =>
                row.settingKey ==
                "is_replace_dashboard_to_analytical_on_sync"
            );

          if (
            isReplaceDashboardToAnalyticalOnSync
          ) {
            localStorage.setItem(
              "isReplaceDashboardToAnalyticalOnSync",
              isReplaceDashboardToAnalyticalOnSync.settingValue
            );
          }


          let isShowUpdatedLoadsheetPdfAtBillingHistory =
            response.find(
              (row) =>
                row.settingKey ==
                "is_show_updated_loadsheet_pdf_at_billing_history"
            );

          if (
            isShowUpdatedLoadsheetPdfAtBillingHistory
          ) {
            localStorage.setItem(
              "isShowUpdatedLoadsheetPdfAtBillingHistory",
              isShowUpdatedLoadsheetPdfAtBillingHistory.settingValue
            );
          }


          let isShowSimpleBillPdfAtBillingHistory =
            response.find(
              (row) =>
                row.settingKey ==
                "is_show_simple_bill_pdf_at_billing_history"
            );

          if (
            isShowSimpleBillPdfAtBillingHistory
          ) {
            localStorage.setItem(
              "isShowSimpleBillPdfAtBillingHistory",
              isShowSimpleBillPdfAtBillingHistory.settingValue
            );
          }

          let isShowRemoteOrderColumnAtAnalyticalDashboard =
            response.find(
              (row) =>
                row.settingKey ==
                "is_show_remote_order_column_at_analytical_dashboard"
            );

          if (
            isShowRemoteOrderColumnAtAnalyticalDashboard
          ) {
            localStorage.setItem(
              "isShowRemoteOrderColumnAtAnalyticalDashboard",
              isShowRemoteOrderColumnAtAnalyticalDashboard.settingValue
            );
          }

          let isShowOrderedBeatsBySalesTeamAtNewAdminDashboard =
            response.find(
              (row) =>
                row.settingKey ==
                "is_show_ordered_beats_by_sales_team_at_new_admin_dashboard"
            );

          if (
            isShowOrderedBeatsBySalesTeamAtNewAdminDashboard
          ) {
            localStorage.setItem(
              "isShowOrderedBeatsBySalesTeamAtNewAdminDashboard",
              isShowOrderedBeatsBySalesTeamAtNewAdminDashboard.settingValue
            );
          }

          let isShowWorkingNotStartedAtDashboard =
            response.find(
              (row) =>
                row.settingKey ==
                "is_show_working_not_started_at_dashboard"
            );

          if (
            isShowWorkingNotStartedAtDashboard
          ) {
            localStorage.setItem(
              "isShowWorkingNotStartedAtDashboard",
              isShowWorkingNotStartedAtDashboard.settingValue
            );
          }


          let isCallOnloadApiAtCreditNoteHistory =
            response.find(
              (row) =>
                row.settingKey ==
                "is_call_onload_api_at_credit_note_history"
            );

          if (
            isCallOnloadApiAtCreditNoteHistory
          ) {
            localStorage.setItem(
              "isCallOnloadApiAtCreditNoteHistory",
              isCallOnloadApiAtCreditNoteHistory.settingValue
            );
          }


          let isCallGeneratedBillsByDateApi =
            response.find(
              (row) =>
                row.settingKey ==
                "is_call_generated_bills_by_date_api"
            );

          if (
            isCallGeneratedBillsByDateApi
          ) {
            localStorage.setItem(
              "isCallGeneratedBillsByDateApi",
              isCallGeneratedBillsByDateApi.settingValue
            );
          }

          let isShowApplyAtGenetateBill =
            response.find(
              (row) =>
                row.settingKey ==
                "is_show_apply_at_generate_bill"
            );

          if (
            isShowApplyAtGenetateBill
          ) {
            localStorage.setItem(
              "isShowApplyAtGenetateBill",
              isShowApplyAtGenetateBill.settingValue
            );
          }

          let isShowEwayAtGenerateBill =
            response.find(
              (row) =>
                row.settingKey ==
                "is_show_eway_at_generate_bill"
            );

          if (
            isShowEwayAtGenerateBill
          ) {
            localStorage.setItem(
              "isShowEwayAtGenerateBill",
              isShowEwayAtGenerateBill.settingValue
            );
          }

          let isShowCancelAtGenerateBill =
            response.find(
              (row) =>
                row.settingKey ==
                "is_show_cancel_at_generate_bill"
            );

          if (
            isShowCancelAtGenerateBill
          ) {
            localStorage.setItem(
              "isShowCancelAtGenerateBill",
              isShowCancelAtGenerateBill.settingValue
            );
          }

          let isShowManageStockProductWise =
            response.find(
              (row) =>
                row.settingKey ==
                "is_show_manage_stock_product_wise"
            );

          if (
            isShowManageStockProductWise
          ) {
            localStorage.setItem(
              "isShowManageStockProductWise",
              isShowManageStockProductWise.settingValue
            );
          }

          let isShowBillDiscountAndCDAtManualOrderBilling =
            response.find(
              (row) =>
                row.settingKey ==
                "is_show_bill_discount_and_cd_at_manual_order_billing"
            );

          if (
            isShowBillDiscountAndCDAtManualOrderBilling
          ) {
            localStorage.setItem(
              "isShowBillDiscountAndCDAtManualOrderBilling",
              isShowBillDiscountAndCDAtManualOrderBilling.settingValue
            );
          }

          let showDiscountAmtEditableAtManualOrderBilling = response.find(
            (row) =>
              row.settingKey ==
              "is_show_discount_amt_editable_at_manual_order_billing"
          );

          if (showDiscountAmtEditableAtManualOrderBilling) {
            localStorage.setItem(
              "showDiscountAmtEditableAtManualOrderBilling",
              showDiscountAmtEditableAtManualOrderBilling.settingValue
            );
          }

          let isShowDiscountAtManualOrder =
            response.find(
              (row) =>
                row.settingKey ==
                "is_show_discount_at_manual_order"
            );

          if (
            isShowDiscountAtManualOrder
          ) {
            localStorage.setItem(
              "isShowDiscountAtManualOrder",
              isShowDiscountAtManualOrder.settingValue
            );
          }

          let isShowAddOrderButtonAtManualOrder =
            response.find(
              (row) =>
                row.settingKey ==
                "is_show_add_order_at_manual_order"
            );

          if (
            isShowAddOrderButtonAtManualOrder
          ) {
            localStorage.setItem(
              "isShowAddOrderButtonAtManualOrder",
              isShowAddOrderButtonAtManualOrder.settingValue
            );
          }


          let isShowSaveAndNextButtonAtAssignBeatSalesTeam =
            response.find(
              (row) =>
                row.settingKey ==
                "is_show_save_and_next_at_assign_beat_salesteam"
            );

          if (
            isShowSaveAndNextButtonAtAssignBeatSalesTeam
          ) {
            localStorage.setItem(
              "isShowSaveAndNextButtonAtAssignBeatSalesTeam",
              isShowSaveAndNextButtonAtAssignBeatSalesTeam.settingValue
            );
          }

          let isCallGetAllVehicleApiAtOutletinvoicing =
            response.find(
              (row) =>
                row.settingKey ==
                "is_call_getall_vehicle_api_at_outlet_invoicing"
            );

          if (
            isCallGetAllVehicleApiAtOutletinvoicing
          ) {
            localStorage.setItem(
              "isCallGetAllVehicleApiAtOutletinvoicing",
              isCallGetAllVehicleApiAtOutletinvoicing.settingValue
            );
          }

          let isCallOnloadApiAtPendingGrnList =
            response.find(
              (row) =>
                row.settingKey ==
                "is_call_onload_api_at_pending_grn_list"
            );

          if (
            isCallOnloadApiAtPendingGrnList
          ) {
            localStorage.setItem(
              "isCallOnloadApiAtPendingGrnList",
              isCallOnloadApiAtPendingGrnList.settingValue
            );
          }


          let isShowSapCreditLimitAtPlaceOrder =
            response.find(
              (row) =>
                row.settingKey ==
                "is_show_sap_credit_limit_at_place_order"
            );

          if (
            isShowSapCreditLimitAtPlaceOrder
          ) {
            localStorage.setItem(
              "isShowSapCreditLimitAtPlaceOrder",
              isShowSapCreditLimitAtPlaceOrder.settingValue
            );
          }

          let isCallNormalProductRateStructureApi =
            response.find(
              (row) =>
                row.settingKey ==
                "is_call_normal_product_rate_structure_api"
            );

          if (
            isCallNormalProductRateStructureApi
          ) {
            localStorage.setItem(
              "isCallNormalProductRateStructureApi",
              isCallNormalProductRateStructureApi.settingValue
            );
          }


          let isShowExcelAtReceivedOrderBill =
            response.find(
              (row) =>
                row.settingKey ==
                "is_show_excel_at_received_order_bill"
            );

          if (
            isShowExcelAtReceivedOrderBill
          ) {
            localStorage.setItem(
              "isShowExcelAtReceivedOrderBill",
              isShowExcelAtReceivedOrderBill.settingValue
            );
          }

          let hideSyncRadiogroupAtPurchaseBillFilter =
            response.find(
              (row) =>
                row.settingKey ==
                "hide_sync_radiogroup_at_purchase_bill_filter"
            );

          if (
            hideSyncRadiogroupAtPurchaseBillFilter
          ) {
            localStorage.setItem(
              "hideSyncRadiogroupAtPurchaseBillFilter",
              hideSyncRadiogroupAtPurchaseBillFilter.settingValue
            );
          }

          let isShowStockInHandAtStockBetweenDate =
            response.find(
              (row) =>
                row.settingKey ==
                "is_show_stock_in_hand_at_stock_between_date"
            );

          if (
            isShowStockInHandAtStockBetweenDate
          ) {
            localStorage.setItem(
              "isShowStockInHandAtStockBetweenDate",
              isShowStockInHandAtStockBetweenDate.settingValue
            );
          }


          let isShowDiscountFreeQtyAtBatchwiseOutletBilling =
            response.find(
              (row) =>
                row.settingKey ==
                "is_show_discount_freeqty_at_batchwise_outlet_billing"
            );

          if (
            isShowDiscountFreeQtyAtBatchwiseOutletBilling
          ) {
            localStorage.setItem(
              "isShowDiscountFreeQtyAtBatchwiseOutletBilling",
              isShowDiscountFreeQtyAtBatchwiseOutletBilling.settingValue
            );
          }


          let isCallOnloadApiOnGrnHistoryTable =
            response.find(
              (row) =>
                row.settingKey ==
                "is_call_onload_api_at_grn_history_table"
            );

          if (
            isCallOnloadApiOnGrnHistoryTable
          ) {
            localStorage.setItem(
              "isCallOnloadApiOnGrnHistoryTable",
              isCallOnloadApiOnGrnHistoryTable.settingValue
            );
          }

          let isShowApproveButtonAtPendingGrnDetails =
            response.find(
              (row) =>
                row.settingKey ==
                "is_show_approve_button_at_pending_grn_details"
            );

          if (
            isShowApproveButtonAtPendingGrnDetails
          ) {
            localStorage.setItem(
              "isShowApproveButtonAtPendingGrnDetails",
              isShowApproveButtonAtPendingGrnDetails.settingValue
            );
          }


          let showExcelReportsBySettingValuesForSubUser = response.find(
            (row) =>
              row.settingKey ==
              "show_excel_reports_index_for_sub_user"
          );

          if (showExcelReportsBySettingValuesForSubUser) {
            localStorage.setItem(
              "showExcelReportsBySettingValuesForSubUser",
              showExcelReportsBySettingValuesForSubUser.settingValue
            );
          }


          let isShowMovementAtTimeline = response.find(
            (row) =>
              row.settingKey ==
              "is_show_movement_at_timeline"
          );

          if (isShowMovementAtTimeline) {
            localStorage.setItem(
              "isShowMovementAtTimeline",
              isShowMovementAtTimeline.settingValue
            );
          }

          let googleApiKey = response.find(
            (row) =>
              row.settingKey ==
              "google_api_key"
          );

          if (googleApiKey) {
            localStorage.setItem(
              "googleApiKey",
              googleApiKey.settingValue
            );
          }

          let isShowSalesTeamHomeAddress = response.find(
            (row) =>
              row.settingKey ==
              "is_show_sales_team_home_address"
          );

          if (isShowSalesTeamHomeAddress) {
            localStorage.setItem(
              "isShowSalesTeamHomeAddress",
              isShowSalesTeamHomeAddress.settingValue
            );
          }


          let isShowBillDiscountAndCDAtOutletOrderHistoryBilling = response.find(
            (row) =>
              row.settingKey ==
              "is_show_bill_discount_and_cd_at_outlet_order_history_billing"
          );

          if (isShowBillDiscountAndCDAtOutletOrderHistoryBilling) {
            localStorage.setItem(
              "isShowBillDiscountAndCDAtOutletOrderHistoryBilling",
              isShowBillDiscountAndCDAtOutletOrderHistoryBilling.settingValue
            );
          }

          let isShowOfferButtonAtBillingPreview = response.find(
            (row) =>
              row.settingKey ==
              "is_show_offer_button_at_billing_preview"
          );

          if (isShowOfferButtonAtBillingPreview) {
            localStorage.setItem(
              "isShowOfferButtonAtBillingPreview",
              isShowOfferButtonAtBillingPreview.settingValue
            );
          }


          let isNewDomainApplicable = response.find(
            (row) =>
              row.settingKey ==
              "is_new_domain_applicable"
          );

          if (isNewDomainApplicable) {
            localStorage.setItem(
              "isNewDomainApplicable",
              isNewDomainApplicable.settingValue
            );
          }

          let isShowAdvanceEnquiryMaster = response.find(
            (row) =>
              row.settingKey ==
              "show_advance_enquiry_master"
          );

          if (isShowAdvanceEnquiryMaster) {
            localStorage.setItem(
              "isShowAdvanceEnquiryMaster",
              isShowAdvanceEnquiryMaster.settingValue
            );
          }

          let showDaysValidationAtSalesTeamExcelReport = response.find(
            (row) =>
              row.settingKey ==
              "show_days_validation_on_sales_team_reports"
          );

          if (showDaysValidationAtSalesTeamExcelReport) {
            localStorage.setItem(
              "showDaysValidationAtSalesTeamExcelReport",
              showDaysValidationAtSalesTeamExcelReport.settingValue
            );
          }


          let showDiscountAmtEditableAtOrderHistoryBilling = response.find(
            (row) =>
              row.settingKey ==
              "is_show_discount_amt_editable_at_order_history_billing"
          );

          if (showDiscountAmtEditableAtOrderHistoryBilling) {
            localStorage.setItem(
              "showDiscountAmtEditableAtOrderHistoryBilling",
              showDiscountAmtEditableAtOrderHistoryBilling.settingValue
            );
          }

          let isShowSalesTeamLocatioWiseDataAtAnalyticalDashboard = response.find(
            (row) =>
              row.settingKey ==
              "is_show_sales_team_location_wise_data_at_analytical_dashboard"
          );

          if (isShowSalesTeamLocatioWiseDataAtAnalyticalDashboard) {
            localStorage.setItem(
              "isShowSalesTeamLocatioWiseDataAtAnalyticalDashboard",
              isShowSalesTeamLocatioWiseDataAtAnalyticalDashboard.settingValue
            );
          }


          let isSalesTeamWiseDataForToken = response.find(
            (row) =>
              row.settingKey ==
              "is_sales_team_wise_data_for_token"
          );

          if (isSalesTeamWiseDataForToken) {
            localStorage.setItem(
              "isSalesTeamWiseDataForToken",
              isSalesTeamWiseDataForToken.settingValue
            );
          }

          let isShowBillTypeAtInvoiceListTable = response.find(
            (row) =>
              row.settingKey ==
              "is_show_bill_type_at_invoice_list_table"
          );

          if (isShowBillTypeAtInvoiceListTable) {
            localStorage.setItem(
              "isShowBillTypeAtInvoiceListTable",
              isShowBillTypeAtInvoiceListTable.settingValue
            );
          }

          let showThermalPrintButtonAndIcon = response.find(
            (row) =>
              row.settingKey ==
              "show_thermal_print_button_and_icon"
          );

          if (showThermalPrintButtonAndIcon) {
            localStorage.setItem(
              "showThermalPrintButtonAndIcon",
              showThermalPrintButtonAndIcon.settingValue
            );
          }

          let isShowSalesTeamCheckInOutTimeAtSalesTeamListDashboard = response.find(
            (row) =>
              row.settingKey ==
              "is_show_sales_team_check_in_out_time_at_sales_team_list_dashboard"
          );

          if (isShowSalesTeamCheckInOutTimeAtSalesTeamListDashboard) {
            localStorage.setItem(
              "isShowSalesTeamCheckInOutTimeAtSalesTeamListDashboard",
              isShowSalesTeamCheckInOutTimeAtSalesTeamListDashboard.settingValue
            );
          }


          let isShowPurchaseOrderPdfProductWise = response.find(
            (row) =>
              row.settingKey ==
              "is_show_purchase_order_pdf_product_wise"
          );

          if (isShowPurchaseOrderPdfProductWise) {
            localStorage.setItem(
              "isShowPurchaseOrderPdfProductWise",
              isShowPurchaseOrderPdfProductWise.settingValue
            );
          }


          let isShowBillDispatchPdfProductWise = response.find(
            (row) =>
              row.settingKey ==
              "is_show_bill_dispatch_pdf_product_wise"
          );
          if (isShowBillDispatchPdfProductWise) {
            localStorage.setItem(
              "isShowBillDispatchPdfProductWise",
              isShowBillDispatchPdfProductWise.settingValue
            );
          }

          let isShowSendCredentialIcon = response.find(
            (row) =>
              row.settingKey ==
              "is_send_email_at_sales_team_save"
          );
          if (isShowSendCredentialIcon) {
            localStorage.setItem(
              "isShowSendCredentialIcon",
              isShowSendCredentialIcon.settingValue
            );
          }

          let linkToRedirectToReportingModule = response.find(
            (row) =>
              row.settingKey ==
              "link_for_redirect_report"
          );
          if (linkToRedirectToReportingModule) {
            localStorage.setItem(
              "linkToRedirectToReportingModule",
              linkToRedirectToReportingModule.settingValue
            );
          }


          await getAccessRoleForLeft({ user: auth.name }).then(
            ({ response, success }) => {
              if (success) {
                localStorage.setItem(
                  "loginUserData",
                  JSON.stringify(response)
                );
                localStorage.setItem("userId", response.id);
                localStorage.setItem(
                  "userStockStakeHolderTypeId",
                  response.stockStakeHolderType.id
                );
                localStorage.setItem(
                  "accessRoleData",
                  JSON.stringify(response.accessRole)
                );
                apiGet({
                  url:
                    endpoint.company +
                    "/with-sessioned-person-info",
                }).then(({ data, success }) => {
                  if (success) {
                    if (
                      data !== null &&
                      data.data !== null &&
                      !data.data.error &&
                      data.data.isActiveFlag == 0
                    ) {
                      showNotification({
                        msg: authenticationMsg,
                        severity: "error",
                      });
                      localStorage.clear();
                    } else {
                      if (
                        data !== null &&
                        data.data !== null &&
                        !data.data.errorMessage.error
                      ) {
                        localStorage.setItem(
                          "firmName",
                          data.data.name
                        );
                        localStorage.setItem(
                          "compName",
                          data.data.company.name
                        );
                        localStorage.setItem(
                          "distributorName",
                          data.data.name
                        );
                        localStorage.setItem(
                          "compName",
                          data.data.company.name
                        );
                        localStorage.setItem(
                          "complogo",
                          data.data.company.logo
                        );
                        localStorage.setItem(
                          "upi",
                          data.data.upi
                        );
                        localStorage.setItem(
                          "compId",
                          data.data.company.id
                        );
                        localStorage.setItem(
                          "districtName",
                          data.data.district === null
                            ? ""
                            : data.data.district.name
                        );
                      }

                      if (
                        response.stockStakeHolderType.userType
                          .id == 1 ||
                        response.stockStakeHolderType.userType
                          .id == 6
                      ) {
                        window.location.replace("/welcome-page");
                      } else if (
                        response.stockStakeHolderType.userType
                          .id == 3
                      ) {
                        getBeatByUserType().then(
                          ({ response, success }) => {
                            if (!success) {
                              showNotification({
                                msg: serverMsg,
                                severity: "error",
                              });
                            } else {
                              localStorage.setItem(
                                "activeBeatList",
                                response.length == 0
                                  ? ""
                                  : JSON.stringify(response)
                              );
                              window.location.replace(
                                "/welcome-page"
                              );
                            }
                          }
                        );
                      } else if (
                        response.stockStakeHolderType.userType
                          .id == 2
                      ) {
                        getBeatByUserType().then(
                          ({ response, success }) => {
                            if (!success) {
                              showNotification({
                                msg: serverMsg,
                                severity: "error",
                              });
                            } else {
                              localStorage.setItem(
                                "activeBeatList",
                                response.length == 0
                                  ? ""
                                  : JSON.stringify(response)
                              );
                              window.location.replace(
                                "/welcome-page"
                              );
                            }
                          }
                        );
                      } else {
                        window.location.replace("/welcome-page");
                      }
                    }
                  } else {
                    showLoador({ loador: false });
                  }
                });
              } else {
                showLoador({ loador: false });
              }
              return { response, success };
            }
          );
        }
      }
    });
  }

  // Reporting opens `/login?token=`. Store it the same way password login stores externalToken, then run the same session setup.
  const beginCarriedTokenLogin = async (sessionToken) => {
    // Remove token from the address bar even if we stop early (offline / error).
    window.history.replaceState(null, "", window.location.pathname);

    if (!navigator.onLine) {
      showNotification({ msg: noInternetMsg, severity: "error" });
      return;
    }

    localStorage.setItem(
      "token",
      Buffer.from(sessionToken).toString("base64")
    );
    localStorage.setItem("trustId", "1");
    sessionStorage.setItem(CARRIED_TOKEN_LOGIN_FLAG, "1");
    showLoador({ loador: true });

    try {
      const { data, success } = await apiGet({
        url: endpoint.userType + "/by-session-user",
      });

      if (!success) {
        sessionStorage.removeItem(CARRIED_TOKEN_LOGIN_FLAG);
        localStorage.removeItem("token");
        showLoador({ loador: false });
        showNotification({ msg: serverMsg, severity: "error" });
        return;
      }

      const userTypeId = data?.data?.id;
      localStorage.setItem("userTypeId", userTypeId);

      // Welcome page loads notices for every user except user type 1 and 6.
      if (userTypeId != 1 && userTypeId != 6) {
        const noticeResult = await getNoticeMsgByUserType();
        if (noticeResult && noticeResult.success) {
          const noticeList =
            noticeResult.response && noticeResult.response.length !== 0
              ? noticeResult.response
              : [];
          localStorage.setItem(
            "noticeMsgListData",
            JSON.stringify(noticeList)
          );
        }
      }

      const { response, success: languageSuccess } = await getActiveLanguage();
      if (!languageSuccess) {
        showNotification({ msg: serverMsg, severity: "error" });
      } else {
        localStorage.setItem("activeLanguageList", JSON.stringify(response));
      }

      await getSettingKeysFunction();
    } catch (e) {
      sessionStorage.removeItem(CARRIED_TOKEN_LOGIN_FLAG);
      localStorage.removeItem("token");
      showLoador({ loador: false });
      showNotification({ msg: serverMsg, severity: "error" });
    }
  };

  useEffect(() => {
    const carriedTokenParam = new URLSearchParams(window.location.search).get(
      "token"
    );
    const carriedToken = carriedTokenParam ? carriedTokenParam.trim() : "";
    if (!carriedToken) {
      return;
    }
    beginCarriedTokenLogin(carriedToken);
  }, []);

  const handleClickShowPassword = () => setShowPassword((show) => !show);
  const Login = () => {
    if (navigator.onLine) {
      if (auth.name !== "" && auth.password !== "") {
        showLoador({ loador: true });
        apiPostWithoutHeader({
          url:
            endpoint.webLogin +
            "?username=" +
            auth.name +
            "&password=" +
            auth.password,
        }).then(async ({ data, success }) => {
          console.log(data.errorMessage != "Exist");
          if (data.errorMessage != "Exist") {
            setPasswordErr("");
            setNameErr("");
            setLoginErr("");
            await login({ username: auth.name, password: auth.password }).then(
              async ({ success }) => {
                if (success) {
                  await apiGet({
                    url: endpoint.userType + "/by-session-user",
                  }).then(({ data, success }) => {
                    if (success) {
                      localStorage.setItem("userTypeId", data.data.id);
                    } else {
                      showNotification({
                        msg: serverMsg,
                        severity: "error",
                      });
                    }
                  });

                  await getNoticeMsgByUserType();

                  await getActiveLanguage().then(({ response, success }) => {
                    showLoador({ loador: false });
                    if (!success) {
                      showNotification({ msg: serverMsg, severity: "error" });
                    } else {
                      localStorage.setItem(
                        "activeLanguageList",
                        response.length == 0 ? "" : JSON.stringify(response)
                      );
                    }
                  });

                  await getSettingKeysFunction();

                } else {
                  showLoador({ loador: false });
                  setLoginErr("Invalid Credential");
                }
              }
            );
          } else {
            setShowLoading(false);
            swal({
              title: alreadyLoggedIn,
              text: "Do you want to log out other devices ?",
              icon: "warning",
              buttons: true,
              dangerMode: true,
              buttons: ["Cancel", "Confirm"],
            }).then(async (willDelete) => {
              if (willDelete) {
                setPasswordErr("");
                setNameErr("");
                setLoginErr("");
                showLoador({ loador: true });
                await login({ username: auth.name, password: auth.password }).then(
                  async ({ success }) => {
                    if (success) {
                      await apiGet({
                        url: endpoint.userType + "/by-session-user",
                      }).then(({ data, success }) => {
                        if (success) {
                          localStorage.setItem("userTypeId", data.data.id);
                        } else {
                          showNotification({
                            msg: serverMsg,
                            severity: "error",
                          });
                        }
                      });

                      await getNoticeMsgByUserType();

                      await getActiveLanguage().then(({ response, success }) => {
                        showLoador({ loador: false });
                        if (!success) {
                          showNotification({
                            msg: serverMsg,
                            severity: "error",
                          });
                        } else {
                          localStorage.setItem(
                            "activeLanguageList",
                            response.length == 0 ? "" : JSON.stringify(response)
                          );
                        }
                      });

                      await getSettingKeysFunction();

                    } else {
                      showLoador({ loador: false });
                      setLoginErr("Invalid Credential");
                    }
                  }
                );
              } else {
                showLoador({ loador: false });
              }
            });
          }
        });
      } else {
        if (auth.name === "" && auth.password === "") {
          setNameErr("Username required");
          setPasswordErr("Password required");
        } else if (auth.name === "") {
          setNameErr("Username required");
          setPasswordErr("");
        } else if (auth.password === "") {
          setPasswordErr("Password required");
          setNameErr("");
        } else {
          setPasswordErr("");
          setNameErr("");
        }
      }
    } else {
      showNotification({ msg: noInternetMsg, severity: "error" });
    }
  };

  const onChange = (e) => {
    const { name, value } = e.target;
    setAuth({
      ...auth,
      [name]: value,
    });
  };

  const onApiCalled = (e) => {
    //href="forgot-password-pre-login"
  };

  return (
    <>
      <div className="new_login_content">
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            gap: "10px",
          }}
        >
          <div className="new_logo_content"></div>
          <Grid className="new_title_content">
            Distribution Management System
          </Grid>
        </div>

        <div
          className="new_login_box3"
        // style={{
        //   marginLeft: "15%",
        //   marginRight: "15%",
        // }}
        >
          <div className="new_login_logo"></div>
          <div className="new_login_box">
            <div>
              <div className="new_login_welcome">Welcome</div>
            </div>
            <div style={{ alignItems: "flex-between" }}>
              <div className="user_lgn_new">
                <div className="new_user_lable">Username</div>
                <TextField
                  color="primary"
                  name="name"
                  size="small"
                  value={auth.name}
                  onChange={onChange}
                  onKeyPress={(e) => e.key === "Enter" && Login()}
                  fullWidth
                  helperText={nameErr ? nameErr : " "}
                  error={nameErr ? true : false}
                  style={{
                    borderRadius: "4px",
                    border: "1px solid #DEDEDE",
                    background: "#ECECEC",
                    width: "360px",
                    height: "41px",
                    flexShrink: "0",
                    marginBottom: "20px",
                    // borderRadius: "17px 17px 17px 17px",
                  }}
                />
                <div className="new_user_lable">Password</div>
                <OutlinedInput
                  color="primary"
                  name="password"
                  size="small"
                  type={showPassword ? "text" : "password"}
                  endAdornment={
                    <InputAdornment
                      position="end"
                      style={{
                        width: "18px",
                        height: "18px",
                        flexShrink: "0",
                        marginRight: "12px",
                      }}
                    >
                      <IconButton onClick={handleClickShowPassword} edge="end">
                        {showPassword ? <Visibility /> : <VisibilityOff />}
                      </IconButton>
                    </InputAdornment>
                  }
                  value={auth.password}
                  onChange={onChange}
                  fullWidth
                  onKeyPress={(e) => e.key === "Enter" && Login()}
                  error={passwordErr ? true : false}
                  style={{
                    borderRadius: "4px",
                    border: "1px solid #DEDEDE",
                    background: "#ECECEC",
                    width: "360px",
                    height: "43px",
                    flexShrink: "0",

                    // borderRadius: "17px 17px 17px 17px",
                  }}
                />
                <FormHelperText error>
                  &nbsp;&nbsp;
                  {loginErr !== "" ? loginErr : " "}
                </FormHelperText>
              </div>
            </div>

            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-end",
              }}
            >
              <div style={{ alignItems: "flex-between" }}>
                <button
                  type="button"
                  onClick={Login}
                  onKeyPress={(e) => e.key === "Enter" && Login()}
                  className="new_login_btn"
                  style={{
                    color: "#FFF",
                    /* button text poppins */
                    fontFamily: "Poppins",
                    fontSize: "16px",
                    fontStyle: "normal",
                    fontWeight: "500",
                    lineHeight: "normal",
                  }}
                >
                  Login
                </button>
              </div>

              <div className="new_forgot_pswd" onClick={onApiCalled}>
                <a href="/forgotPassword" style={{ color: "#004969" }}>
                  Forgot Password
                </a>
              </div>
            </div>
            <div className="main_footer"></div>
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                gap: "10px",
              }}
            >
              <div className="new_footer">
                Powered by <div className="new_footer_logo"></div>
              </div>
              <div className="new_footer_link">
                <a
                  href="https://www.byteelephants.com/"
                  style={{ color: "#004969" }}
                >
                  BytesElephants.com
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      {showLoading && <Loading />}
    </>
  );
};
const mapStateToProps = (state) => ({
  user: state,
  common: state.common,
});

const mapDispatchToProps = {
  login,
  getAccessRoleForLeft,
  getNoticeMsgByUserType,
  logOut,
  showNotification,
  showLoador,
  getSetting,
  getActiveLanguage,
  getBeatByUserType,
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(Login));

{
  /* <>
      <div align="center">
        <div className="new_content login">
          <div className="dash_login">
            <Grid item container justifyContent="space-between">
              <Grid item md={4}></Grid>
              <Grid item md={4}>
                <div className="lgn_bx">
                  <h3 className="lgn_title">Login Form</h3>

                  <div className="lgn_container">
                    <div className="user_lgn_new">
                      <div className="user_label">Username</div>
                      <div className="user_field">
                        <TextField
                          color="primary"
                          name="name"
                          size="small"
                          value={auth.name}
                          onChange={onChange}
                          onKeyPress={(e) => e.key === "Enter" && Login()}
                          fullWidth
                          helperText={nameErr ? nameErr : " "}
                          error={nameErr ? true : false}
                        />
                      </div>
                    </div>

                    <div className="user_lgn_new">
                      <div className="user_label">Password</div>
                      <div className="user_field">
                        <OutlinedInput
                          color="primary"
                          name="password"
                          size="small"
                          type={showPassword ? "text" : "password"}
                          endAdornment={
                            <InputAdornment position="end">
                              <IconButton
                                onClick={handleClickShowPassword}
                                edge="end"
                              >
                                {showPassword ? (
                                  <Visibility />
                                ) : (
                                  <VisibilityOff />
                                )}
                              </IconButton>
                            </InputAdornment>
                          }
                          value={auth.password}
                          onChange={onChange}
                          fullWidth
                          onKeyPress={(e) => e.key === "Enter" && Login()}
                          error={passwordErr ? true : false}
                        />
                        <FormHelperText error>
                          &nbsp;&nbsp;&nbsp;&nbsp;
                          {passwordErr !== "" ? passwordErr : " "}
                        </FormHelperText>
                      </div>
                    </div>

                    <div style={{ marginTop: 20 }} className="lgn_btn">
                      <button
                        type="button"
                        onClick={Login}
                        onKeyPress={(e) => e.key === "Enter" && Login()}
                        className="register_btn"
                      >
                        Login
                      </button>
                    </div>
                    <FormHelperText error>
                      &nbsp;&nbsp;
                      {loginErr !== "" ? loginErr : " "}
                    </FormHelperText>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "flex-end",
                      }}
                    >
                      <div className="user_label" onClick={onApiCalled}>
                        <a href="/forgotPassword">Forgot Password</a>
                      </div>
                    </div>
                  </div>
                </div>
              </Grid>
              <Grid item md={4}></Grid>
            </Grid>
          </div>
        </div>
      </div>
      {showLoading && <Loading />} */
}
